import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { BottomBarComponent } from './bottom-bar/bottom-bar.component';
import { GeneralModalComponent } from './general-modal/general-modal.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    SidenavComponent,
    HeaderComponent,
    SpinnerComponent,
    BottomBarComponent,
    GeneralModalComponent
  ],
  imports: [RouterModule, SharedModule],
  exports: [SpinnerComponent, GeneralModalComponent]
})
export class LayoutModule {}
